import type { IconData } from '@stacksjs/iconify-core'

export const drinkFoodFruit: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5.5 0A2.5 2.5 0 0 1 8 2.5a2.5 2.5 0 0 1 5 0V3H3v-.5A2.5 2.5 0 0 1 5.5 0M8 3a6.5 6.5 0 1 1 0 13A6.5 6.5 0 0 1 8 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default drinkFoodFruit
